import React, { useEffect } from "react";
import useEventStore from "../stores/EventStore";
import './EventDate.css';

export default function EventDateAdminPage() {
  const { voteCountPerDateWithName, getVoteCountPerDateWithName } = useEventStore();

  useEffect(() => {
    getVoteCountPerDateWithName();
    const interval = setInterval(async () => {
      try {
        getVoteCountPerDateWithName();
      } catch (error) {
        console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
      }
    }, 5000); // polls every 5 seconds
    return () => clearInterval(interval);
  }, []);

  // Group by voteDate instead of eventDateId
  const groupedVotes = {};

  voteCountPerDateWithName.forEach(({ voteDate, username, voteValue }) => {
    if (!groupedVotes[voteDate]) {
      groupedVotes[voteDate] = { yes: [], no: [] };
    }
    if (voteValue === 1) {
      groupedVotes[voteDate].yes.push(username);
    } else if (voteValue === 0) {
      groupedVotes[voteDate].no.push(username);
    }
  });

  return (
    <div className="admin-container">
      <h2>Abstimmungsergebnisse</h2>
      <div className="overflow-x-auto">
        <table className="attendance-table">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Gutes Datum</th>
              <th>Schlechtes Datum</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(groupedVotes).map(([voteDate, votes]) => (
              <tr key={voteDate}>
                <td>{voteDate}</td>
                <td>{votes.yes.length > 0 ? votes.yes.map((name, idx) => <div key={idx}>{name}</div>) : "—"}</td>
                <td>{votes.no.length > 0 ? votes.no.map((name, idx) => <div key={idx}>{name}</div>) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
